/* How the app talks about a centipawn number.
 *
 * Split out of grader.js because three unrelated places need the vocabulary
 * and only one of them needs the engine: the drill and the coaching record
 * describe a mined habit, debrief.js describes a move in a Rival game, and
 * proPitch.js describes a whole deck to somebody deciding whether to pay.
 * Importing grader.js for a string ladder would have dragged the UCI client
 * along with it — and `MIN_CP_LOSS` was already declared twice, in grader.js
 * and debrief.js, with a comment in the second one noting that it had to match
 * the first. Two constants that must agree and cannot be checked is a bug
 * waiting for someone to tune one of them.
 *
 * Pure: a number in, a phrase out. No engine, no state, no catalog.
 */
import { t } from "../i18n.js";

/* Below this the engine is saying "these are the same move, really" — a
 * win-rate gap that flagged the card was noise. Also the floor under every
 * claim the app makes about what something cost: under 40cp it says nothing
 * rather than dressing up a rounding error as advice. */
export const MIN_CP_LOSS = 40;

/* "costs about a pawn" — a phrase, not a number, because the number is a
 * search result and pretending otherwise oversells it. */
export function severityLabel(cpLoss) {
  if (typeof cpLoss !== "number") return null;
  if (cpLoss >= 900) return t("cost.lost");
  if (cpLoss >= 300) return t("cost.piece");
  if (cpLoss >= 150) return t("cost.pawnHalf");
  if (cpLoss >= 80) return t("cost.pawn");
  return t("cost.little");
}
